<template>
  <listing-layout>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="h2 mb-0">Judges</h1>
    </div>
    <div slot="content">
      <div>
        <h2 class="h3 mb-3">Judges Applications</h2>
          <router-link
            tag="button"
            :to="{ name: 'Admin Judges Applications List' }"
            class="btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5">
              Manage Applications
          </router-link>
      </div>
      <div>
        <h2 class="h3 mb-3">List of Judges</h2>
          <router-link
            tag="button"
            :to="{ name: 'Judges list' }"
            class="btn btn-primary px-xl-5 mt-2 mt-sm-0 mb-5">
              View List
          </router-link>
      </div>
      <div>
        <h2 class="h3 mb-3">Judge Surveys</h2>
        <div class="drafts" v-if="loaded">
          <div v-if="drafts && drafts.length">
            <div class="draft" v-for="draft in drafts">
              <div class="draft-name m-2 m-md-0">
                {{ draft.name }}
              </div>
              <div class="actions">
                <button
                  class="btn btn-primary px-xl-5 m-1 my-md-0 mr-2"
                  @click="downloadPdf(draft.id)"
                  :disabled="processing"
                >
                  <div v-if="processing" class="d-flex align-items-center">
                    <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
                  </div>
                  <div v-else>
                    Download PDF
                  </div>
                </button>
                <button
                  class="btn btn-primary px-xl-5 m-1 my-md-0 mr-2"
                  @click="downloadCsv(draft.id)"
                  :disabled="processing"
                >
                  <div v-if="processing" class="d-flex align-items-center">
                    <div class="spinner-border spinner-border-sm text-light mr-2" role="status"></div>
                  </div>
                  <div v-else>
                    Download CSV
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            There are no reports.
          </div>
        </div>
        <div class="loader" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </listing-layout>
</template>

<script>

import GETSTORE from '@/store/memberProfileStore.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import listingLayout from '@/components/ListingLayout'
import axios from "axios"

export default {
  name: 'JudgeAdminDashboard',
  mixins: [GETSTORE, LEGACYBROWSERS],
  components: {
    'listing-layout': listingLayout
  },
  data() {
    return {
      userID: localStorage.userID,
      userRole: localStorage.role,
      drafts: [],
      loaded: false,
      processing: false
    }
  },
  mounted() {
    this.loadDrafts()
  },
  methods: {
    loadDrafts() {
      axios.get(`${this.$api}/judges/surveys/drafts`).then((response) => {
        if (response.data.status === 'success') {
          this.error = ''
          this.drafts = response.data.data
          this.loaded = true
        } else {
          this.error = 'Unable to receive data from the server. Please reload the page.'
        }
      })
    },
    downloadPdf(draftId) {
      this.processing = true
      axios.get(`${this.$api}/judges/surveys/reports/${draftId}/pdf`, {
        Accept: 'application/pdf',
        responseType: 'arraybuffer'
      }).then((response) => {
        this.processing = false

        const newBlob = new Blob([response.data], { type: 'application/pdf' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }
        const data = window.URL.createObjectURL(newBlob)
        const link = document.createElement('a')
        link.href = data
        link.download = 'survey_reports.pdf'
        link.click()
        link.remove()
        setTimeout(() => {
          window.URL.revokeObjectURL(data)
        }, 100)
      })
    },
    downloadCsv(draftId) {
      this.processing = true
      axios.get(`${this.$api}/judges/surveys/reports/${draftId}/csv`, {
        responseType: 'blob'
      }).then((response) => {
        this.processing = false

        if (window.navigator.msSaveOrOpenBlob) {
          const blobObject = new Blob([response.data])
          window.navigator.msSaveOrOpenBlob(blobObject, `survey_report.csv`)
        } else if (this.isIOS()) {
          const reader = new FileReader()
          reader.fileName = `survey_report.csv`
          const out = new Blob([response.data], { type: 'data:text/csv;charset=utf-8' })

          reader.onload = () => {
            window.location.href = reader.result
          }
          reader.readAsDataURL(out)
        } else {
          const url = window.URL
            ? window.URL.createObjectURL(new Blob([response.data], { type: 'data:text/csv;charset=utf-8' }))
            : window.webkitURL.createObjectURL(new Blob([response.data], { type: 'data:text/csv;charset=utf-8' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `survey_report.csv`)
          document.body.appendChild(link)
          link.click()
          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          }, 0)
        }
      })
    }
  }
}
</script>

<style scoped>
.drafts {
  display: flex;
  flex-direction: column;
}

.draft {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid var(--gray-75);
}

.draft-name {
  font-size: 18px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/Admin/JudgeAdminDashboard.vue